import React from 'react'
import PropTypes from 'prop-types'
import Text from './Text'
import Signature from './Signature'
import Checkbox from './Checkbox'

export default class Value extends React.Component {
  static propTypes = {
    field: PropTypes.object,
    onChange: PropTypes.func
  }

  onChange(key) {
    return value => {
      this.props.onChange({
        text: null,
        signatureId: null,
        checked: null,
        [key]: value
      })
    }
  }

  render() {
    if (this.props.field.type === 'checkbox') {
      return <Checkbox {...this.props} onChange={this.onChange('checked')} />
    }
    if (this.props.field.type === 'text') {
      return <Text {...this.props} onChange={this.onChange('text')} />
    }
    if (this.props.field.type === 'signature') {
      return <Signature {...this.props} onChange={this.onChange('signatureId')} />
    }
    return <span />
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/Field/Menu/Value/index.js